const initQuizCloseButton = () => {
   const quiz = document.querySelector(".quiz");
   if (!quiz) return;

   const quizRadioInputs = quiz.querySelectorAll("input[type=radio");
   const quizProgressButtons = quiz.querySelectorAll(".quiz__slide-btn");
   const quizSlides = quiz.querySelectorAll(".quiz__slide");
   
   quiz.addEventListener("click", (evt) => {
      if (evt.target.closest(".quiz__header-close")) {
         quiz.classList.remove('is-active');
         document.body.classList.remove('scroll-lock');
         quizRadioInputs.forEach(input => input.checked = false);
         quizProgressButtons.forEach(button => button.disabled = true);
         quizProgressButtons[0].disabled = false;
         quizSlides.forEach(slide => slide.style.display = "none");
         quizSlides[0].style.display = "flex";
      }
   })
}

export default initQuizCloseButton;
